<template>
	<RegisteredPageLayout :loading="loading" :error="error">
		<template #header>
			<nav class="page-nav">
				<router-link :to="{ name: 'Users' }" :class="['nav-link', { active: $route.name === 'Users' }]">
					Users
				</router-link>
				<router-link :to="{ name: 'Invitations' }" :class="['nav-link', { active: $route.name === 'Invitations' }]">
					Invitations
				</router-link>
				<router-link :to="{ name: 'AdminWireguard' }" :class="['nav-link', { active: $route.name === 'AdminWireguard' }]">
					Wireguard
				</router-link>
				<router-link :to="{ name: 'AdminSocks' }" :class="['nav-link', { active: $route.name === 'AdminSocks' }]">
					SOCKS
				</router-link>
				<router-link :to="{ name: 'AdminMTProxy' }" :class="['nav-link', { active: $route.name === 'AdminMTProxy' }]">
					MTProxy
				</router-link>
				<router-link :to="{ name: 'UserWireguard' }" class="nav-link">
					User Page
				</router-link>
				<button @click="logout" class="nav-link nav-link-logout">Logout</button>
			</nav>
		</template>
		<template #body>
			<slot></slot>
		</template>
	</RegisteredPageLayout>
</template>

<script>
import RegisteredPageLayout from '../_PageLayout.vue'

export default {
	name: 'AdminPageLayout',
	components: {
		RegisteredPageLayout
	},
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		error: {
			type: String,
			default: ''
		}
	},
	methods: {
		logout() {
			localStorage.removeItem('authToken')
			localStorage.removeItem('userEmail')
			this.$router.push({ name: 'Login' })
		}
	}
}
</script>

<style>
</style>

